/* tslint:disable */
/* eslint-disable */
/**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ConsentType } from "./consent-type";

/**
 *
 * @export
 * @interface Speaker
 */
export interface Speaker {
  /**
   *
   * @type {string}
   * @memberof Speaker
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Speaker
   */
  projectId: string;
  /**
   *
   * @type {string}
   * @memberof Speaker
   */
  name: string;
  /**
   *
   * @type {ConsentType}
   * @memberof Speaker
   */
  consent: ConsentType;
}
